/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconNotificationsActiveFilled from 'DesignSystem/Svgs/TysiaIconNotificationsActiveFilled/index'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/App/Account/Topbar/Inbox/Content/MessageIndicatorIcon/Error"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TysiaIconNotificationsActiveFilled
  viewPath={`${viewPath}/TysiaIconNotificationsActiveFilled`}
 width={16}
 height={16}
 fill={dtColorsWhite}
/>
{children}
</React.Fragment>)
}